<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('settings')"
      :directory="$t('settings')"
      :icon="'settings'"
    />
    <app-tab v-if="dataLoaded" :tabs="tabs" :icon="tabIcon" />
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

export default {
  name: "Setting",
  props: {
    marketPlaceVersion: {
      default: false,
    },
    appUrl: {},
  },
  mixins: [FormMixin],

  data() {
    return {
      dataLoaded: false,
      loggedInUser: {},
      tabIcon: "settings",
      tabs: [
        {
          name: this.$t("general"),
          title: this.$t("general"),
          component: "app-general-settings",
          permission: "",
        },
        {
          name: this.$t("custom_fields"),
          title: this.$t("custom_fields"),
          component: "app-custom-field",
          permission: "",
          headerButton: {
            label: this.$t("add_custom_field"),
            class: "btn btn-primary",
          },
        },
        {
          name: this.$t("email_setup"),
          title: this.$t("email_setup"),
          component: "app-email-setup",
          permission: "",
          props: "",
        },
        {
          name: this.$t("broadcast_setup"),
          title: this.$t("broadcast_setup"),
          component: "app-broadcast-setup",
          permission: "",
          props: "",
        },
        {
          name: this.$t("notification"),
          title: this.$t("notification"),
          component: "app-notification-settings",
          permission: "",
        },
        {
          name: this.$t("update"),
          title: this.$t("update"),
          component: "app-update",
          permission: "",
          props: "",
        },
      ],
    };
  },

  mounted() {
    this.tabs.forEach((el) => {
      el["props"] = {
        isMarketPlaceVersion: this.marketPlaceVersion,
        appUrl: this.appUrl,
      };
    });
    this.dataLoaded = true;
  },
};
</script>
